import { render, staticRenderFns } from "./OcorrenciaForm.vue?vue&type=template&id=54e30900&"
import script from "./OcorrenciaForm.vue?vue&type=script&lang=js&"
export * from "./OcorrenciaForm.vue?vue&type=script&lang=js&"
import style0 from "./OcorrenciaForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports